import { useDatabaseEntity } from './useDatabaseEntity';

export interface WorkflowInstanceDetails {
  id: string;
  title: string;
  titleTemplate: string;
  templateId: string;
  lockedVersion: number;
  versionPreference: 'FollowLatest' | 'Pin';
  parameterValues: Record<string, any>;
  stepStates: Record<string, any>;
  createdAt: string;
}

export function useWorkflowInstance(instanceId: string | undefined) {
  const { entity, loading, error } = useDatabaseEntity<WorkflowInstanceDetails>(instanceId, {
    entityType: 'Workflow instance',
    build: (database, id) => {
      const obj = database.workflow_instances()[id];
      if (!obj) return null;
      return {
        id,
        title: obj.title(),
        titleTemplate: obj.title_template(),
        templateId: obj.template_id(),
        lockedVersion: obj.locked_version(),
        versionPreference: obj.version_preference() as 'FollowLatest' | 'Pin',
        parameterValues: obj.parameter_values(),
        stepStates: obj.step_states(),
        createdAt: obj.created_at(),
      };
    },
  });
  return { instance: entity, loading, error };
}
